import { observer } from 'mobx-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Page from 'components/Page';
import PoliciesSection from 'modules/Policies/layout/Policies/PoliciesSection';
import { LogoWrapper } from 'modules/Policies/styled';
import store from 'store';

import TISLogo from '@common/assets/icons/TISLogo.svg';
import useModel from '@common/helpers/useModel';
import PoliciesModel from '@common/models/Policies/Policies';

function Policies() {
	const { t } = useTranslation();
	const currentService = store.services.current.id;

	const policies = useModel(PoliciesModel, { service_id: currentService }, [currentService]);

	return (
		<Page
			title={t('policies.main')}
			type="list"
			isLoading={policies.loading}
			sx={{ position: 'relative' }}
		>
			<PoliciesSection policies={policies.data} />
			<LogoWrapper>
				<TISLogo style={{ width: '342px', height: '310px' }} />
			</LogoWrapper>
		</Page>
	);
}

export default observer(Policies);
